import { IconMap } from 'components/_const_assets/icons'
import { Img } from 'components/basic/Img'
import { Button } from 'components/Phantom/Button'
import { Icon, IconName } from 'components/Phantom/Icon'
import { Pod4FAQ } from 'components/Pod4FAQ'
import { Type } from 'components/Type'
import { FC } from 'react'
import styles from './AutopilotCompareTable.module.scss'
import { AutopilotCompareTableProps } from './types'

interface ITableItem {
	icon: IconName
	iconAlt: string
	featureName: string
	standardStatus: string
	enchancedStatus: string
}

const TableData: ITableItem[] = [
	{
		icon: 'TemperatureLight',
		iconAlt: 'Temperature icon',
		featureName: 'Automatic temperature',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
	// {
	// 	icon: IconMap.cool,
	// 	iconAlt: 'Cool icon',
	// 	featureName: 'Scheduled temperature',
	// 	standardStatus: IconMap.gray_checkmark,
	// 	enchancedStatus: IconMap.blue_checkmark,
	// },
	{
		icon: 'VibrationLight',
		iconAlt: 'Vibration icon',
		featureName: 'Vibration and thermal alarm',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
	{
		icon: 'HeartReportLight',
		iconAlt: 'Heart report icon',
		featureName: 'Sleep and health reports',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
	// {
	// 	icon: IconMap.price_tag,
	// 	iconAlt: 'Discount icon',
	// 	featureName: 'Discounts on upgrades and accessories',
	// 	standardStatus: IconMap.gray_checkmark,
	// 	enchancedStatus: IconMap.blue_checkmark,
	// },
	{
		icon: 'TwoUsersLight',
		iconAlt: 'Two users icon',
		featureName: 'Two sleep profiles',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
	{
		icon: 'EightBoxLight',
		iconAlt: 'Eight icon',
		featureName: 'Complimentary maintenance insert delivery',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
	{
		icon: 'SnoringLight',
		iconAlt: 'Snoring icon',
		featureName: 'Snoring detection',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
	{
		icon: 'SnoreMitigationCustom',
		iconAlt: 'Snoring mitigation icon',
		featureName: 'Snoring mitigation',
		standardStatus: IconMap.gray_checkmark,
		enchancedStatus: IconMap.blue_checkmark,
	},
]

export const AutopilotBrieferStoreConnected = () => {
	return <AutopilotCompareTable />
}

export const AutopilotCompareTable: FC<AutopilotCompareTableProps> = (props) => {
	const { title = 'Put your sleep on Autopilot', showFAQ = true, ctaUrl = '/product/pod-cover', faqData } = props

	return (
		<section className={styles.container}>
			<div className={styles.inner}>
				<header className={styles.header}>
					<Type.MegaHeadline as={'h2'}>{title}</Type.MegaHeadline>
				</header>

				<div className={styles.table_heading}>
					<Type.Headline6 as={'span'}>Standard</Type.Headline6>
					<Type.Headline6 as={'span'}>Enhanced</Type.Headline6>
				</div>
				<ul className={styles.table}>
					{TableData.map((item, index) => (
						<li key={index}>
							<span className={styles.icon}>
								<Icon
									name={item.icon}
									color={'black'}
								/>
							</span>
							<Type.Headline6
								as={'p'}
								className={styles.feature_name}
							>
								{item.featureName}
							</Type.Headline6>
							<Img
								alt="Standard status icon"
								src={item.standardStatus}
								simple
								lazy={false}
							/>
							<Img
								alt="Enhanced status icon"
								src={item.enchancedStatus}
								simple
								lazy={false}
							/>
						</li>
					))}
					<li>
						<span className={styles.icon}>
							<Img
								alt={'Shield check icon'}
								src={IconMap.shield_check}
								simple
								lazy={false}
							/>
						</span>
						<Type.Headline6
							as={'p'}
							className={styles.feature_name}
						>
							Extended warranty
						</Type.Headline6>
						<Type.Headline6
							as={'span'}
							className={styles.feature_status}
						>
							2-year
						</Type.Headline6>
						<Type.Headline6
							as={'span'}
							className={styles.feature_status}
						>
							5-year
						</Type.Headline6>
					</li>
				</ul>
				<div className={styles.warranty}>
					<div className={styles.warranty_content}>
						<div className={styles.warranty_logo}>
							<svg
								width="37"
								height="57"
								viewBox="0 0 37 57"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									id="Fill 1"
									fillRule="evenodd"
									clipRule="evenodd"
									d="M26.7637 16.7185C26.7637 18.6412 25.2044 20.1992 23.2818 20.1992H13.5742C11.6517 20.1992 10.0925 18.6412 10.0925 16.7185V12.0421C10.0925 10.1192 11.6517 8.56123 13.5742 8.56123H23.2818C25.2044 8.56123 26.7637 10.1192 26.7637 12.0421V16.7185ZM26.7637 44.2872C26.7637 46.2099 25.2044 47.7681 23.2818 47.7681H13.5742C11.6517 47.7681 10.0925 46.2099 10.0925 44.2872V37.8263C10.0925 35.9036 11.6517 34.3454 13.5742 34.3454H23.2818C25.2044 34.3454 26.7637 35.9036 26.7637 37.8263V44.2872ZM27.2215 0H9.63467C4.31039 0.00240828 0 4.31433 0 9.63905V17.1012C0 21.0259 2.32925 24.3696 5.67173 25.8792V27.2594C2.32925 28.7687 0 32.1329 0 36.036V46.7117C0 52.038 4.31302 56.351 9.63927 56.351H27.2165C32.5429 56.351 36.8562 52.038 36.8562 46.7117V36.036C36.8562 32.1329 34.5269 28.7687 31.1842 27.2594V25.8792C34.5269 24.3696 36.8562 21.0044 36.8562 17.1012V9.63905C36.8562 4.31433 32.5456 0.00240828 27.2215 0Z"
									fill={'white'}
								/>
							</svg>
						</div>
						<Type.Headline3 className={styles.warranty_headline}>5-year extended warranty</Type.Headline3>
						<Type.SmallPrint className={styles.warranty_disclaimer}>*Only included with Enhanced plan. Terms apply</Type.SmallPrint>
						<Type.Body1>
							For up to 5 years following your initial purchase date, we will replace or repair your Pod when the damage is the result of a defect in material or workmanship as long as you purchased
							through this site and have the Autopilot Enhanced plan active.
						</Type.Body1>

						<Button.TextLink
							id={'autopilot-compare-table-cta'}
							href={ctaUrl}
							className={styles.cta}
						>
							Learn more
						</Button.TextLink>
					</div>
				</div>
				{showFAQ && <Pod4FAQ {...faqData} />}

				<Type.SmallPrint className={styles.final_disclaimer}>
					*These health-tracking algorithms are constantly being improved and clinically tested by our Research and Development team using gold-standard testing methods like ECGs. Our team has
					collected over 5,000 nights of data to train, enhance, and test each one of our algorithms and we will continue to refine them as our data set grows over time.
				</Type.SmallPrint>
			</div>
		</section>
	)
}
